import React from 'react';
import { Sparkles } from 'lucide-react';

interface AISummaryProps {
  summary: string;
}

const AISummary: React.FC<AISummaryProps> = ({ summary }) => {
  return (
    <div className="premium-card" style={{ padding: '1.5rem', display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
      <span className="icon-tile" aria-hidden="true">
        <Sparkles size={20} />
      </span>
      <div>
        <h3 className="section-title" style={{ marginBottom: '0.75rem' }}>AI summary</h3>
        <p style={{ color: 'var(--text-main)', margin: 0, maxWidth: 'none', fontSize: '0.98rem', lineHeight: 1.75 }}>{summary}</p>
      </div>
    </div>
  );
};

export default AISummary;
